// ** MUI Imports
import Divider from '@mui/material/Divider'
import CardContent from '@mui/material/CardContent'
import CustomerDetailsTable from './CustomerDetailsTable'
import PhoneNumberTable from './PhoneNumberTable'
import Typography from '@mui/material/Typography'

const TabSettings = () => {
    return (
        <form>
            <CardContent sx={{ pb: 0 }}>
                <Typography sx={{ fontSize: 16, color: 'CornflowerBlue' }}>
                    Customer Settings
                </Typography>
               <CustomerDetailsTable />
            </CardContent>

            <CardContent sx={{ pb: 0 }}>
                <Typography sx={{ fontSize: 16, color: 'CornflowerBlue' }}>
                   Phone Numbers
                </Typography>
                <PhoneNumberTable />
            </CardContent>
        </form>
    )
}
export default TabSettings
